export function formatDate(date, delimiter) {
    if(!(date instanceof Date) || isNaN(date)) {
        return null;
    }

    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join(delimiter);
}


export function dateFromString(dateString) {
    let parts = dateString.split("-"); // Split the string into an array [yyyy, mm, dd]
    let year = parseInt(parts[0]);
    let month = parseInt(parts[1]) - 1; // Months are zero-based in JavaScript, so subtract 1
    let day = parseInt(parts[2]);

    return new Date(year, month, day);
}

export function reformatDate(dateString) {
    if (!dateString) {
        return
    }

    let date;

    //console.log("reformat date " + dateString);
    if(dateString.indexOf(". ") === -1) {
        return dateString;
    }

    date = dateString.split(". ");

    if(date[2] === "NaN") {
        return;
    }

    return date[2] + "-" + date[1] + "-" + date[0];
}

export function getPrettyDatesRange(dateFrom, dateTo) {
    let dateFromObject = dateFromString(dateFrom);
    let dateToObject = dateFromString(dateTo);

    if(!dateFromObject || !dateToObject) return;

    const dateFromMonth = dateFromObject.getMonth() + 1;
    const dateToMonth = dateToObject.getMonth() + 1;

    let dateFromFormatted = dateFromObject.getDate() + ". " + dateFromMonth + ". " + dateFromObject.getFullYear();
    let dateToFormatted = dateToObject.getDate() + ". " + dateToMonth + ". " + dateToObject.getFullYear();

    return dateFromFormatted + " - " + dateToFormatted;
}

export function getReservationMaxDate() {
   return new Date(new Date().getFullYear() + 2, 11, 31);
}